import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";

const Level = ({ page, edit }) => {
  const breadcrumbsList = [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    { text: "Add New Medicine", link: "" },
  ];

  const tabItems = [
    { key: "1", label: "Medicine Details" },
    { key: "2", label: "FAQ & Others" },
  ];
  return (
    <>
      <Breadcrumbs
        className="healthsyMasterBreadCrumbs pb-0"
        breadcrumbsList={breadcrumbsList}
      />

      {/* <CustomTabs
        tabs={tabItems}
        activeKey={activeTab}
        onChange={() => { }}
      /> */}
      <div className="bg-light d-flex align-items-center gap-5 p-2 my-2">
        <div className={page === 1 ? "active-step fs18fwb" : "inactive-step"}>
          <div>Medicine Details</div>
        </div>
        <div className={page === 2 ? "active-step" : "inactive-step"}>
          <div>FAQ & Others</div>
        </div>
      </div>
    </>
  );
};

export default Level;
